import { useMemo } from "react"
import { appStoreUrls } from "popopo-msg"
import { SimplePage } from "popopo-lib-react/simple-pages"
import { getMessages } from "popopo-lib-react/simple-pages/messages"
import { useSearchParams } from "react-router-dom"
import { useOpenAppHandler } from "../lib/useOpenAppHandler"
import "../style/simple-pages.scss"

const APP_ICON_URL = "/assets/app-icons/android/res/mipmap-xxxhdpi/appicon.png"

function isIOSInAppBrowser(userAgent: string): boolean {
  const isIOS = /iPhone|iPad|iPod/.test(userAgent)
  if (!isIOS) return false

  const isSafari = /Safari\//.test(userAgent)
    && !/CriOS|FxiOS|EdgiOS/.test(userAgent)
    && !/Twitter|FBAN|FBAV|Instagram|Line\/|KAKAOTALK/.test(userAgent)

  return !isSafari
}

/**
 * Public landing page for all shared URLs.
 * This is a simple interstitial page that displays:
 * - App install links (App Store / Google Play)
 * - Button to open the app
 *
 * ボタン押下時の挙動は useOpenAppHandler を参照。
 *
 * OGP meta tags are handled by SSR (Cloud Functions).
 * This component does not require authentication.
 */
export const PublicLanding = () => {
  const [searchParams] = useSearchParams()
  const msg = getMessages("ja")
  const handleOpenApp = useOpenAppHandler()

  // デバッグ用: ?__inapp=true で InAppブラウザの挙動をシミュレート可能
  const debugInApp = searchParams.get("__inapp") === "true"

  const isInApp = useMemo(
    () => debugInApp || (typeof navigator !== "undefined" && isIOSInAppBrowser(navigator.userAgent)),
    [debugInApp]
  )

  return (
    <SimplePage
      locale="ja"
      mobileAppBanner={isInApp ? {
        appIconUrl: APP_ICON_URL,
        onOpen: handleOpenApp,
      } : undefined}
    >
      <img
        src={APP_ICON_URL}
        alt="POPOPO"
        className="simple-page__app-icon"
      />
      <h1 className="simple-page__title">
        {msg.publicLanding.titleLine1}
        <br />
        {msg.publicLanding.titleLine2}
      </h1>
      <>
          <div className="simple-page__store-buttons">
            <a
              href={appStoreUrls.iOS}
              target="_blank"
              rel="noopener noreferrer"
              className="simple-page__store-button"
            >
              <img
                src="/assets/app-store-badge-ja.svg"
                alt="App Storeからダウンロード"
                className="simple-page__store-badge"
              />
            </a>
            <a
              href={appStoreUrls.android}
              target="_blank"
              rel="noopener noreferrer"
              className="simple-page__store-button"
            >
              <img
                src="/assets/google-play-badge-ja.svg"
                alt="Google Play で手に入れよう"
                className="simple-page__store-badge"
              />
            </a>
          </div>
          <button
            onClick={handleOpenApp}
            className="simple-page-button simple-page-button--filled"
          >
            {msg.publicLanding.openAppButton}
          </button>
        </>
    </SimplePage>
  )
}
